import { Theme, Components } from '@mui/material/styles';
import HeadingNowBook from '../fonts/heading-now-book.woff';
import HeadingNowRegular from '../fonts/heading-now-regular.woff';

/* eslint-disable import/prefer-default-export */
export const cssCustomizations: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: `
      @font-face { 
        font-family: 'Heading Now Book'; 
        src: url(${HeadingNowBook}) format('woff');
        font-weight: normal; 
        font-style: normal; 
      }

      @font-face { 
        font-family: 'Heading Now Regular'; 
        src: url(${HeadingNowRegular}) format('woff');
        font-weight: normal; 
        font-style: normal; 
      }

      html {
        font-size: 14px;
      }
        input[type="password"] {
        font-family: Verdana, sans-serif;
      }
    `
  },
};
